import { Component, forwardRef, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { filter, Subscription, take } from 'rxjs';
import { AuthService } from '../../../shared/services/auth.service';
import { IOption } from '../../controls/models/option';
import { ProjectService } from '../shared/services/project.service';

@Component({
    selector: 'app-select-multiple-project-phase',
    templateUrl: './select-multiple-project-phase.component.html',
    styleUrl: './select-multiple-project-phase.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectMultipleProjectPhaseComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SelectMultipleProjectPhaseComponent implements ControlValueAccessor, OnDestroy {

  @Input() id: string = 'select-project-phase';
  @Input() label: string = 'Phase';

  onChange: any = () => { };
  onTouched: any = () => { };

  private _values: any[] | undefined;
  get values() {
    return this._values;
  }
  set values(values) {
    this._values = values;
    this.onChange(values);
    this.onTouched();
  }

  loading: boolean = true;
  subscriptions: Subscription = new Subscription();
  options: IOption<string>[] = [];

  constructor(
    private _authService: AuthService,
    private _projectService: ProjectService,
  ) {
    const userSubscription = this._authService.currentUserSubject
    .pipe(
      filter(user => !!user),
      take(1)
    )    
    .subscribe(user => {
      if (user) {
        this.getProjectPhases();
      }
    });

    this.subscriptions.add(userSubscription);
  }

  writeValue(values: any[]): void {
    this.values = values;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  getProjectPhases() {
    const getPhases = this._projectService.getPhases().subscribe(response => {
      if (response.success) {
        this.options = response.content.map(x => ({ value: x.description, label: x.description }));
      }

      this.loading = false;
    });

    this.subscriptions.add(getPhases);
  }
}
